import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
   @import url('https://fonts.googleapis.com/css?family=Material+Icons');
   body {
    font-family: Poppins,sans-serif;
    font-size: 100%;
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    text-shadow: rgba(0,0,0,.01) 0 0 1px;
  }

  /* force gpu rendering on mobile devices*/
  @media only screen and (max-width: 768px) {
    body:after {
      content: '';
      display: inline-block;
      position: absolute;
      width: 1px;
      height: 1px;
      background-color: black;
      top:0;
      right: 0;
      -webkit-transform: translate3d(0, 0, 0);
      transform: translate3d(0, 0, 0);
    }
  }

  h1,h2,h3,h4,h5,div,p,button,a,span,section,header,nav,body,form,fieldset,input {
    margin: 0;
    padding: 0;
    font-weight: inherit;
  }

  h1,h2,h3,h4,h5,div,p,button,a,span,section,header,nav,form,fieldset {
    font-size: inherit;
  }

  fieldset {
    border: none;
  }
`;

export default GlobalStyle;
